import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import './styles/pack-background.css';
import App from './App';
import { appVariant } from './config';
import { applyPackBackground } from './utils/packBackground';

applyPackBackground(appVariant);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
